import { render, staticRenderFns } from "./safetySet.vue?vue&type=template&id=511aff17&scoped=true&"
import script from "./safetySet.vue?vue&type=script&lang=js&"
export * from "./safetySet.vue?vue&type=script&lang=js&"
import style0 from "./safetySet.vue?vue&type=style&index=0&id=511aff17&scoped=true&lang=css&"
import style1 from "./safetySet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511aff17",
  null
  
)

export default component.exports